


let baseUrl = 'https://www.miraclink.com/prod-api'
// let baseUrl = 'http://192.168.0.104:8806'
export {
    baseUrl,
}
